export function formatCurrency(amount: number, currency: 'usd' | 'inr' = 'usd') {
  const withFixedDecimals = (amount / 100).toFixed(2);
  switch (currency.toLowerCase()) {
    case 'inr':
      return `₹${withFixedDecimals}`;
    default:
      return `$${withFixedDecimals}`;
  }
}
